// extracted by mini-css-extract-plugin
export var text = "styles-module--text--71902";
export var title = "styles-module--title--6d99e";
export var wrapper = "styles-module--wrapper--8d318";